import { useTranslation } from 'react-i18next';

import { motion } from 'framer-motion';
import { LogOut } from 'lucide-react';

import { Button } from '@lemoment/ui-kit';

import { useAuthStore } from '../../../core';
import { useLogout } from '../../auth';
import { LanguageSelector } from '../components/LanguageSelector';
import { ThemeSelector } from '../components/ThemeSelector';

export const SettingsPage = () => {
  const { t } = useTranslation();
  const crew = useAuthStore((s) => s.crew);
  const logout = useLogout();

  return (
    <div className="mx-auto max-w-xl space-y-8 px-5 pb-32 pt-20 md:pt-12">
      <motion.header
        initial={{ opacity: 0, y: 12 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ type: 'spring', stiffness: 280, damping: 28 }}
      >
        <h1 className="font-display text-3xl font-semibold tracking-tight">
          {t('settings.title')}
        </h1>
      </motion.header>

      <section className="rounded-2xl border border-border bg-card/80 lift p-6">
        <ThemeSelector />
        <div className="rule-citrus my-4" />
        <LanguageSelector />
      </section>

      <section className="rounded-2xl border border-border bg-card/80 lift p-6">
        <div className="flex items-center justify-between gap-4">
          <div className="flex min-w-0 items-center gap-3">
            <span className="font-display flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-lemon-soft/70 text-base font-semibold text-lemon-ink dark:text-lemon">
              {crew?.displayName?.charAt(0) ?? '?'}
            </span>
            <div className="min-w-0">
              <p className="font-display truncate text-base font-semibold tracking-tight">
                {crew?.displayName ?? t('settings.account')}
              </p>
              {crew?.email ? (
                <p className="truncate text-xs text-muted-foreground">
                  {crew.email}
                </p>
              ) : null}
            </div>
          </div>
          <Button
            variant="outline"
            size="sm"
            onClick={logout}
            className="shrink-0 gap-1.5"
          >
            <LogOut className="size-4" />
            {t('settings.logout')}
          </Button>
        </div>
      </section>
    </div>
  );
};
